<script lang="ts" setup>
import { CATALOG_PAGE_TYPES } from '~/constants/catalogPageTypes';
import { getSelectedMulticardOffer, isMulticardV2Offer } from '~/utils/multicard';

const { selectedOffer, selectedSizeId, currentPageType } = storeToRefs(useCatalogStore());
const { isCatalogScrollRestorationPending } = useCatalogScrollRestoration();

const isShowLoyaltyModal = ref(false);

const loyalty = computed(() => {
  if (isMulticardV2Offer(selectedOffer.value)) {
    return getSelectedMulticardOffer(selectedOffer.value, selectedSizeId.value)?.loyalty ?? null;
  }

  if (currentPageType.value === CATALOG_PAGE_TYPES.OFFER_GROUP_PAGE) {
    if (!selectedSizeId.value) return null;

    return selectedOffer.value.offers?.find((offer) => offer.id === selectedSizeId.value)?.loyalty ?? null;
  } else {
    return selectedOffer.value.loyalty ?? null;
  }
});
const loyaltyCache = useState<{ productId: number; value: number } | null>('product-page-loyalty', () => null);

watch(
  loyalty,
  (value) => {
    if (value !== null) {
      loyaltyCache.value = {
        productId: selectedOffer.value.product_id,
        value,
      };
    }
  },
  { immediate: true },
);

const displayedLoyalty = computed(() => {
  if (loyalty.value !== null) return loyalty.value;

  if (isCatalogScrollRestorationPending.value && loyaltyCache.value?.productId === selectedOffer.value.product_id) {
    return loyaltyCache.value.value;
  }

  return null;
});
</script>

<template>
  <button
    v-if="displayedLoyalty"
    class="product-page-loyalty-block"
    @click="isShowLoyaltyModal = true"
  >
    <div class="flex items-center gap-2">
      <span class="font-bold">{{ displayedLoyalty.toLocaleString('ru-RU') }}</span>

      <SvgoLoyaltyF
        :font-controlled="false"
        class="size-4"
        filled
      />

      <span class="text-sm">будет начислено за покупку</span>
    </div>

    <div class="product-page-loyalty-block__show-more">
      <div class="hidden sm:block md:hidden lg:block">Подробнее</div>

      <SvgoChevronRight
        :font-controlled="false"
        class="size-3"
        filled
      />
    </div>

    <LoyaltyModal
      v-model="isShowLoyaltyModal"
      @close="isShowLoyaltyModal = false"
    />
  </button>
</template>

<style lang="scss" scoped>
.product-page-loyalty-block {
  display: flex;
  gap: 4px;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  border: 1px solid $black-10;
  border-radius: 8px;
  background-color: $white;

  &__show-more {
    display: flex;
    gap: 4px;
    align-items: center;
    color: $black-40;
    font-size: $text-xs;
    transition: color 0.2s;
  }

  &:hover {
    .product-page-loyalty-block__show-more {
      color: $label-violet;
    }
  }
}
</style>
